<template>
	<div
		class="payment-offer-card"
		:class="{
			'is-selected': isSelected,
			'has-multiple': hasMultiple,
			'-t-light': lightTheme,
		}"
		@click="handleSelect"
	>
		<div
			v-if="imgUrl"
			class="payment-offer-card__content-image"
		>
			<img
				class="payment-offer-card__image-img"
				:src="$Helpers.getScaledImageUrl(imgUrl, 100)"
			>
		</div>
		<div class="payment-offer-card__content-info">
			<div class="payment-modal__offer-title">
				{{ title }}
			</div>
			<div
				v-if="description"
				class="payment-modal__offer-desc"
			>
				{{ description }}
			</div>
			<div
				v-if="info"
				class="payment-modal__offer-desc"
			>
				{{ info }}
			</div>
		</div>
		<div class="payment-offer-card__content-price">
			<div class="payment-offer-card__price">
				{{ price }}
			</div>
			<div class="payment-offer-card__currency">
				{{ currencyCode }} {{ validityInfo ? ` / ${validityInfo}` : '' }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:  'PaymentOfferCard',
	props: {
		title: {
			type:     String,
			required: true,
		},
		description: {
			type:    String,
			default: null,
		},
		info: {
			type:    String,
			default: null,
		},
		imgUrl: {
			type:    String,
			default: null,
		},
		price: {
			type:    String,
			default: null,
		},
		currencyCode: {
			type:    String,
			default: null,
		},
		validityInfo: {
			type:    String,
			default: null,
		},
		isSelected: {
			type:    Boolean,
			default: false,
		},
		hasMultiple: {
			type:    Boolean,
			default: false,
		},
		lightTheme: {
			type:    Boolean,
			default: false,
		},
	},
	methods: {
		handleSelect() {
			this.$emit('select');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.payment-offer-card {
	--color-payment-offer-card-primary: var(--color-soft-white);
	--color-payment-offer-card-primary-selected: var(--color-shadow-grey);
	--color-payment-offer-card-secondary: var(--color-grey-300);
	--color-payment-offer-card-secondary-selected: var(--color-grey-800);
	--color-payment-offer-card-background: var(--color-grey-900);
	--color-payment-offer-card-background-selected: var(--color-grey-400);
	--color-payment-offer-card-border-hover: var(--color-grey-700);

	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: $sp4;
	padding: $sp5 $sp4-5;
	background-color: var(--color-payment-offer-card-background);
	border-radius: $border-radius--lg;
	border: 2px solid transparent;
	transition: background-color $trans-time-fast, border-color $trans-time-fast;

	&.-t-light {
		--color-payment-offer-card-primary: var(--color-grey-200);
		--color-payment-offer-card-primary-selected: var(--color-shadow-grey);
		--color-payment-offer-card-secondary: var(--color-grey-400);
		--color-payment-offer-card-secondary-selected: var(--color-grey-200);
		--color-payment-offer-card-background: var(--color-grey-950);
		--color-payment-offer-card-background-selected: var(--color-grey-800);
		--color-payment-offer-card-border-hover: var(--color-grey-800);
	}

	&.is-selected {
		background-color: var(--color-payment-offer-card-background-selected);
	}

	&.has-multiple {
		cursor: pointer;

		&:hover:not(.is-selected) {
			border-color: var(--color-payment-offer-card-border-hover);
		}
	}

	@include size(sm-up) {
		align-items: center;
	}
}

.payment-offer-card__content-image {
	aspect-ratio: 1/1;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 48px;
	width: 48px;
}

.payment-offer-card__image-img {
	height: 48px;
	object-fit: contain;
}

.payment-offer-card__content-info {
	flex-grow: 1;
}

.payment-modal__offer-title {
	@include font(primary, medium, normal, fs-100);
	margin-bottom: $sp1;
	color: var(--color-payment-offer-card-primary);
	transition: color $trans-time-fast;

	.payment-offer-card.is-selected & {
		color: var(--color-payment-offer-card-primary-selected);
	}
}

.payment-modal__offer-desc {
	@include font-size(fs-80);
	margin-bottom: $sp1;
	color: var(--color-payment-offer-card-secondary);
	transition: color $trans-time-fast;

	.payment-offer-card.is-selected & {
		color: var(--color-payment-offer-card-secondary-selected);
	}
}

.payment-offer-card__content-price {
	text-align: right;
}

.payment-offer-card__price {
	@include font(primary, medium, normal, fs-150);
	line-height: 1;
	color: var(--color-payment-offer-card-primary);
	transition: color $trans-time-fast;

	.payment-offer-card.is-selected & {
		color: var(--color-payment-offer-card-primary-selected);
	}
}

.payment-offer-card__currency {
	@include font-size(fs-60);
	color: var(--color-payment-offer-card-secondary);
	transition: color $trans-time-fast;
	white-space: nowrap;

	.payment-offer-card.is-selected & {
		color: var(--color-payment-offer-card-secondary-selected);
	}
}

</style>
